export const COGNITO = {
  REGION: "ap-south-1",
  USER_POOL_ID: "ap-south-1_ch1ZnfNHI",
  APP_CLIENT_ID: "3udhb0pn0530dd565h9vbojm2d",
};